import React, { Component } from "react";
// Components
import Button from "./components/Button";
import Hero from "./components/Hero";
import Jumbotron from "./components/Jumbotron";
import Jumboend from "./components/Jumboend";
import Section from "./components/Section";
import Pitch from "./components/Pitch";
import Footer from "./components/Footer";
// Images
import logos from "./images/g-suite-logos.png";
// Content
import Features from "./content/Features";
import Expert from "./content/Expert";
import Formation from "./content/Formation";

class Content extends Component {
  render() {
    const pitch1 =
      "Consultez et synchronisez l'ensemble de vos données sur tous vos appareils. Vous pouvez collaborer et communiquer facilement, organiser des réunions et des sessions de travail en ligne.";
    const pitch2 =
      "G Suite est VOTRE solution : simple d'utilisation, facile à implanter et à moindre coût. Nous sommes là pour vous aider à effectuer votre virage numérique.";
    const quote2 =
      "Tout ce dont vous avez besoin dans un seul environnement numérique.";
    const imgStyle = {
      marginTop: "20px",
      marginBottom: "30px",
      maxWidth: "100%"
    };
    return (
      <main>
        <Hero />
        <div className="">
          <Jumbotron />
          <Section type="prospection">
            <div className="container">
              <div className="row">
                <div className="col-md-6 d-flex flex-column align-items-center">
                  <img style={imgStyle} src={logos} alt="G Suite" />
                  <ul className="features">
                    <li>
                      <p>Communiquer avec votre équipe</p>
                      <p>Contactez vos collègues où qu'ils soient.</p>
                    </li>
                    <li>
                      <p>Créer vos documents</p>
                      <p>Tout ce dont vous avez besoin pour donner vie à votre projet.</p>
                    </li>
                    <li>
                      <p>Accéder à vos données</p>
                      <p>Stockez vos fichiers et trouvez instantanément ce dont vous avez besoin.</p>
                    </li>
                    <li>
                    <p>Contrôler les accès</p>
                    <p>Gérez facilement vos comptes utilisateur, appareils et données en toute sécurité.</p>
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h2>{quote2}</h2>
                  <Pitch>
                    <p>{pitch1}</p>
                    <p>{pitch2}</p>
                    <Button text="Contactez-nous"/>
                  </Pitch>
                </div>
              </div>
            </div>
          </Section>

          <Features />
          <Expert />
          <Formation />
          <Jumboend />
        </div>
        <Footer />
      </main>
    );
  }
}

export default Content;
